import {  MapBrowserEvent } from "ol";
import BaseLayer from "ol/layer/Base";
import RenderFeature from "ol/render/Feature";
import { hoverLayer, selectionLayer } from "../layers";
import { setSelectedFeatureCount } from "../redux/slice/interactSlice";
import { store } from "../redux/store";
//import { hoverLayer , selectionLayer } from "../layers";
import { mapState } from "./mapstate";

/**
 * Limits the hover to specific layers.
 * @param layer The layer.
 * @returns true if hover, false if not.
 */
const hoverLayerFilter = (layer: BaseLayer) : boolean => {
  return (
    true //layer !== hoverLayer
  );
};



/**
 * Hightlights the selectable measuring points.
 * @param event The hover event.
 */
export const hoverEvent = (event: MapBrowserEvent<UIEvent>) => {
  const features = event.map.getFeaturesAtPixel(event.pixel, { layerFilter: hoverLayerFilter });
  const feature = features.length > 0 && features[0] ? features[0] : undefined;
  let hoverFeature = mapState.hoverFeature;
  if (!feature || feature !== hoverFeature) {
    hoverLayer.getSource()?.clear();
    hoverFeature = undefined;
    hoverLayer.changed();
  }
  if (feature && feature !== hoverFeature && feature.get('layer') === 'gst' && feature instanceof RenderFeature) {
      mapState.hoverFeature = feature;
      hoverLayer.changed();
  }
}

/**
 * Limits the hover to specific layers.
 * @param layer The layer.
 * @returns true if hover, false if not.
 */
 const selectionLayerFilter = (layer: BaseLayer) => {
  return (
     layer !== selectionLayer
  );
};

export const selectEvent = (event: MapBrowserEvent<UIEvent>) => {
  const features = event.map.getFeaturesAtPixel(event.pixel, { layerFilter: selectionLayerFilter });
  const feature = features.length > 0 && features[0] ? features[0] : undefined;
  if(feature?.get('layer')==='gst') {
    const fid = `${feature?.get('kg')}_${feature?.get('gnr')}`;
    if(mapState.selectedFeatures.get(fid)) {
      mapState.selectedFeatures.delete(fid);
    } else {
      mapState.selectedFeatures.set(fid, feature);
    }
    store.dispatch(setSelectedFeatureCount(mapState.selectedFeatures.size));
    selectionLayer.changed();
 
  }
  console.log("feature "+feature); 
  console.log( feature);
};
